import React, { useRef } from "react";

/**
 * QuestionImage.
 *     -Image to Display in Question
 */
export function QuestionVideo(props) {
  console.log("QuestionVideo -> props", props);
  if (!props.video) {
    return null;
  }

  return (
    // <h1> This is Dummy</h1>
    //eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      width="440"
      height="440"
      autoPlay
      loop
      controls
      //onClick={togglePlayPause}
      //onKeyDown={(e) => e.key === "Space" && togglePlayPause()}
    >
      <source src={props.video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
}
